import type { CalculatorFormatValue } from '@elfsight/configurator-contracts';
import { formatSuffixNumber } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';

export function useResultValueFormatter() {
  const { thousandsSeparator, decimalSeparator } = useSettings();

  return (value?: number | string, options?: CalculatorFormatValue) => {
    if (value && options?._mode === 'string') {
      return value;
    }

    if (typeof value === 'number') {
      return formatSuffixNumber(value, {
        prefix: options?.prefix,
        suffix: options?.suffix,
        minimumFractionDigits: options?.decimalPlaces,
        maximumFractionDigits: options?.decimalPlaces,
        thousandsSeparator,
        decimalSeparator
      });
    }

    return '—';
  };
}
